var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_451)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000488281 9.05074C-0.000488281 13.5252 3.24926 17.246 7.49951 18.0005V11.5002H5.24951V9.00049H7.49951V7.00024C7.49951 4.75024 8.94926 3.50074 10.9998 3.50074C11.6493 3.50074 12.3498 3.60049 12.9993 3.70024V6.00049H11.8495C10.7493 6.00049 10.4995 6.55024 10.4995 7.25074V9.00049H12.8995L12.4998 11.5002H10.4995V18.0005C14.7498 17.246 17.9995 13.526 17.9995 9.05074C17.9995 4.07299 13.9495 0.000488281 8.99951 0.000488281C4.04951 0.000488281 -0.000488281 4.07299 -0.000488281 9.05074Z",
    fill: "#D5D9DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(-0.000244141 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ae110039c8974a57478a6848db7ba41b.svg";
export { ForwardRef as ReactComponent };